import React from 'react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAnalytics } from './services/AnalyticsService';
import { initErrorTracking } from './services/ErrorTrackingService';

initErrorTracking();
initAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    onUncaughtError: Sentry.reactErrorHandler(),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  }
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
